import { render } from "./AdminViewPayment.vue?vue&type=template&id=242b6e9a"
import script from "./AdminViewPayment.vue?vue&type=script&lang=js"
export * from "./AdminViewPayment.vue?vue&type=script&lang=js"

import "./AdminViewPayment.vue?vue&type=style&index=0&id=242b6e9a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__